import { State } from "./Type";

const state: State = {
  loading: false,
};

export default state;
